<div dynamicGrid [tableContainerElement]="tableContainer" [selector]="selector" fxLayout="column" fxLayoutGap="10px" >
  <h2 class="page-header left">MGO Proceso de Errores</h2>
  <div fxLayout="row" fxLayout.lt-md="column" class="right">
    <button mat-icon-button class="view-remito-buttons" *ngIf="hideMultipleProcess"
            [disabled]="disableMultipleReprocessButton"><mat-icon>autorenew</mat-icon></button>
  </div>

  <div #tableContainer class="table-height table-flex">
    <table mat-table [dataSource]="dataSource" matSort>

      <!-- Row Checkbox -->
      <ng-container matColumnDef="checkbox">
        <th mat-header-cell *matHeaderCellDef scope="col"></th>
        <td mat-cell *matCellDef="let element" class="center">
          <mat-checkbox (change)="onChange(element)" [(ngModel)]="element.isChecked">
          </mat-checkbox>
        </td>
      </ng-container>

      <!-- File Name Column -->
      <ng-container matColumnDef="nombreDeArchivo">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Nombre de Archivo
          <rem-string-filter #tableFilter columnDef="nombreDeArchivo" [operators]="operators" (filterChange)="filterChange($event);"></rem-string-filter>
        </th>
        <td mat-cell *matCellDef="let element" class="cell-width-description">
           <span>
                {{element.nombreDeArchivo}}
           </span>
        </td>
      </ng-container>

      <!-- Shipper Number Column -->
      <ng-container matColumnDef="nroShipper">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Nro Shipper
          <rem-string-filter #tableFilter columnDef="nroShipper" [operators]="operators" (filterChange)="filterChange($event);"></rem-string-filter>
        </th>
        <td mat-cell  class="center-padding" *matCellDef="let element">
              <span>
                {{element.nroShipper}}
              </span>
        </td>
      </ng-container>

      <!-- Transporte Error Column -->
      <ng-container matColumnDef="transporteError">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Transporte
          <rem-string-filter #tableFilter columnDef="transporteError" [operators]="operators" (filterChange)="filterChange($event);"></rem-string-filter>
        </th>
        <td mat-cell  class="center-padding" *matCellDef="let element">  {{ element.transporteError }} </td>
      </ng-container>

      <!-- Destinatario Error Column -->
      <ng-container matColumnDef="destinatarioError">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Destinatario
          <rem-string-filter #tableFilter columnDef="destinatarioError" [operators]="operators" (filterChange)="filterChange($event);"></rem-string-filter>
        </th>
        <td mat-cell  class="center-padding" *matCellDef="let element"> {{element.destinatarioError}} </td>
      </ng-container>

      <!-- DUNS Column -->
      <ng-container matColumnDef="dunsError">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Destinatario <br> DUNS
          <rem-string-filter #tableFilter columnDef="dunsError" [operators]="operators" (filterChange)="filterChange($event);"></rem-string-filter>
        </th>
        <td mat-cell *matCellDef="let element"  class="center-padding">
          {{element.dunsError}}
        </td>
      </ng-container>

      <!-- Dock Column -->
      <ng-container matColumnDef="dockError">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Cód Dock
          <rem-string-filter #tableFilter columnDef="dockError" [operators]="operators" (filterChange)="filterChange($event);"></rem-string-filter>
        </th>
        <td mat-cell *matCellDef="let element"  class="center-padding">
          {{element.dockError}}
        </td>
      </ng-container>

      <!-- Fec Proceso Column -->
      <ng-container matColumnDef="fecProceso">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Fec Proceso
          <rem-date-filter #tableFilter columnDef="fecProceso" [operators]="dateOperators" (filterChange)="filterChange($event);"></rem-date-filter>
        </th>
        <td mat-cell  class="center-padding" *matCellDef="let element"> {{element.fecProceso | customDate}} </td>
      </ng-container>

      <!-- Reprocess Button Column -->
      <ng-container matColumnDef="reprocessButtons">
        <th mat-header-cell *matHeaderCellDef scope="col"></th>
        <td mat-cell *matCellDef="let element"  class="left">
          <button mat-icon-button class="view-remito-buttons" *ngIf="showReprocessButton"
                  [disabled]="disableReprocessButton" (click)="reprocessMgoFile(element)">
            <mat-icon>autorenew</mat-icon>
          </button>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>
  <mat-paginator #paginator
                 [pageSize]="10"
                 [pageSizeOptions]="[10, 15, 20, 25]">
  </mat-paginator>
</div>

